// Copyright aptihealth, inc. 2019 All Rights Reserved
import React from "react";

const CardSecondary = (props) => {
  let classes = "CardSeconday position-relative";

  if (props.className) {
    classes = classes + " " + props.className;
  }

  return (
    <section onClick={props.onClick || null} className={classes} style={props.style}>
      {props.children}
    </section>
  );
};

export default CardSecondary;
